// extracted by mini-css-extract-plugin
module.exports = {"box":"PlatformCreditScore_box__EOdmT","content":"PlatformCreditScore_content__3SxNu"};